import { useEffect, useState } from 'react'
import { trackExplainerPlay } from '../../analytics/track'
import { explainerVideoId } from './trade-landing-config'

export function TradeExplainer() {
  const videoId = explainerVideoId()
  const [playing, setPlaying] = useState(false)
  const youtubeEmbed = videoId
    ? `https://www.youtube-nocookie.com/embed/${videoId}?rel=0&autoplay=1`
    : undefined

  useEffect(() => {
    if (videoId || !import.meta.env.DEV) return
    console.info('[Perfect Predict] Explainer video id is not set (VITE_PERFECT_PREDICT_EXPLAINER_VIDEO_ID).')
  }, [videoId])

  function playVideo() {
    if (!videoId) return
    setPlaying(true)
    trackExplainerPlay('trade_landing')
  }

  return (
    <aside id="watch-video" className="tl-video tl-video--embed" aria-labelledby="tl-video-title">
      <div className="tl-video__head tl-m-only">
        <h2 className="tl-video__title-m">See the Complete Process</h2>
        {videoId ? (
          <button type="button" className="tl-video__sub-m" onClick={playVideo}>
            Watch the 2-minute explainer
          </button>
        ) : (
          <p className="tl-video__sub-m">Watch the 2-minute explainer</p>
        )}
      </div>
      <h2 id="tl-video-title" className="tl-video__sr">
        Watch the 2-Minute Explainer
      </h2>
      <p className="tl-video__sr">How Prediction Trading Works</p>

      <div className="tl-video__frame">
        {videoId && playing && youtubeEmbed ? (
          <iframe
            title="How Prediction Trading Works"
            src={youtubeEmbed}
            loading="lazy"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
            referrerPolicy="strict-origin-when-cross-origin"
          />
        ) : (
          <div
            className="tl-video__poster"
            role="img"
            aria-label="How Prediction Trading Works — Gold and Silver, SAFE BALANCE AGGRESSIVE, BUY or SELL, target, stop, illustrative potential return, MetaTrader 5 execution"
          >
            {videoId ? (
              <img
                className="tl-video__thumb tl-m-only"
                src={`https://i.ytimg.com/vi/${videoId}/hqdefault.jpg`}
                alt=""
                width={480}
                height={360}
              />
            ) : null}
            <div className="tl-poster">
              <p className="tl-poster__kicker">XAUUSD · Gold &amp; Silver</p>
              <p className="tl-poster__title">How Prediction Trading Works</p>
              <div className="tl-poster__pills" aria-hidden="true">
                <span>SAFE</span>
                <span className="is-on">BALANCE</span>
                <span>AGGRESSIVE</span>
              </div>
              <div className="tl-poster__dirs" aria-hidden="true">
                <span className="is-buy">BUY</span>
                <span className="is-sell">SELL</span>
              </div>
              <dl className="tl-poster__metrics">
                <div>
                  <dt>Target</dt>
                  <dd>3.0%</dd>
                </div>
                <div>
                  <dt>Stop</dt>
                  <dd>1.0%</dd>
                </div>
                <div>
                  <dt>Potential</dt>
                  <dd>+150%*</dd>
                </div>
              </dl>
              <p className="tl-poster__exec">Execution on MetaTrader 5</p>
              <p className="tl-poster__note">*Illustrative only. Returns are not guaranteed.</p>
            </div>
            {videoId ? (
              <button
                type="button"
                className="tl-video__play"
                aria-label="Play How Prediction Trading Works"
                onClick={playVideo}
              >
                <span className="tl-video__play-icon" aria-hidden="true" />
              </button>
            ) : (
              <button
                type="button"
                className="tl-video__play is-disabled"
                disabled
                aria-disabled="true"
                aria-label="Explainer video coming soon"
              >
                <span className="tl-video__play-icon" aria-hidden="true" />
              </button>
            )}
          </div>
        )}
      </div>
      {!videoId ? <p className="tl-video__soon">Explainer video coming soon.</p> : null}
    </aside>
  )
}
